
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';

export const adminGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isInitialized()) {
        return resolveAdmin(authService, router);
    }

    return toObservable(authService.isInitialized).pipe(
        filter(Boolean),
        take(1),
        map(() => resolveAdmin(authService, router)),
    );
};

function resolveAdmin(authService: AuthService, router: Router): boolean | ReturnType<Router['createUrlTree']> {
    if (!authService.isAuthenticated()) {
        return router.createUrlTree(['/login']);
    }
    if (authService.isAdmin()) {
        return true;
    }
    return router.createUrlTree(['/dashboard']);
}
